import * as React from "react"

import { cn } from "@/lib/utils"

/* Campo de texto — arquivo do shadcn, reestilizado para a Colmeia.
 *
 * O fundo é NATA e não transparente: dentro de uma célula de mel ou de areia
 * um campo transparente some, e "onde eu digito" tem de ser óbvio sem ler
 * rótulo. O que separa o campo da célula é o degrau de campo de cor, mais o
 * fio de borda; nunca uma sombra interna.
 *
 * Altura --toque (40px no desktop, 44 no celular): a régua de alvo de toque
 * vale nos dois, porque é o mesmo componente. */

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-toque w-full min-w-0 rounded-lg border border-input bg-nata px-3 py-1 text-corpo transition-[color,border-color,box-shadow] outline-none",
        // Placeholder é TEXTO e por isso é --tinta-3 (4,8:1), não --tinta-4
        // (2,0:1). --tinta-4 é para seta e marcador, onde não há o que ler.
        "placeholder:text-tinta-3 selection:bg-acao-tinta selection:text-tinta",
        // O contorno escurece sob o ponteiro. Num formulário de vinte campos,
        // saber qual deles vai receber o clique antes de clicar é a diferença
        // entre percorrer e adivinhar.
        "hover:border-tinta-3 hover:not-focus-visible:not-disabled:bg-nata",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-apoio file:font-medium file:text-foreground",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25",
        "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20",
        className
      )}
      {...props}
    />
  )
}

export { Input }
